import React, { FC } from "react";

import { Box, Flex, HStack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { Button } from "@components/buttons";
import { LinkWrapper } from "@components/Link";
import responsiveStyle from "@lib/theme/responsiveStyle";
import { ROUTES } from "@utils/constants";

const SuccessFooter: FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Flex
        direction="row-reverse"
        px={responsiveStyle({ mobile: "0.5rem", desktop: "1.5rem" })}
        py={responsiveStyle({ mobile: "1rem", desktop: "1.125rem" })}
        mx={responsiveStyle({ mobile: "-0.5rem", desktop: "0" })}
        justify="space-between"
        background="grey.light"
      >
        <HStack spacing="2rem">
          <LinkWrapper href={ROUTES.LANDING}>
            <Button as="a" variant="secondary" label={t("order-action-homepage")} />
          </LinkWrapper>
        </HStack>
      </Flex>
    </Box>
  );
};
export default SuccessFooter;
